export enum TimeStatus {
    ON_TIME = 'OnTime',
    ONBOARDING = 'OnBoarding',
    DELAY = 'Delay',
    DEPARTED = 'Departed',
    CANCELLED = 'Cancelled',
}

export enum TimeStatusLabel {
    ON_TIME = 'ON TIME',
    ONBOARDING = 'BOARDING',
    DELAY = 'DELAYED',
    DEPARTED = 'DEPARTED',
    CANCELLED = 'CANCELLED'
}